import {AbstractControl, ValidatorFn} from '@angular/forms';

// use recipient === true for input that will get error about the same value
export function SamePasswordValidator(inputToCompare: string, recipient?: boolean): ValidatorFn {
  return (c: AbstractControl): { [key: string]: any } | null => {
    const areSame: boolean = c.value && c.value === c.parent.get(inputToCompare)?.value;

    if (areSame && recipient) {
      return {password: 'same'};
    }

    if (c.parent && c.parent.get(inputToCompare)?.touched && !recipient) {
      c.parent.get(inputToCompare)?.markAsTouched();
      c.parent.get(inputToCompare)?.updateValueAndValidity();
    }

    return null;
  };
}
